<template>
<div class="container-fluid" style="height: 100vh;">
  <div class="row align-items-center" style="height: 100%;">
    <div class="col-md-3" style="height: 97%">
      <zettelkasten-search v-on:lemma-selected="onLemmaSelected"></zettelkasten-search>
    </div>
    <div class="col-md-9" style="height: 97%; border-left: 1px solid  lightgrey">
      <zettelkasten-lemma v-bind:lemma-i-d="lemmaID" v-bind:entry-i-ds="entryIDs" v-bind:super-lemma="superLemma"></zettelkasten-lemma>
    </div>
  </div>
</div>
</template>

<script>
import ZettelkastenSearch from '@/components/ZettelkastenSearch'
import ZettelkastenLemma from '@/components/ZettelkastenLemma'

export default {
  name: 'Zettelkasten',

  components: {
    ZettelkastenSearch,
    ZettelkastenLemma
  },

  data () {
    return {
      lemmaID: -1,
      entryIDs: [],
      superLemma: false
    }
  },

  methods: {
    onLemmaSelected: function (val) {
      this.lemmaID = val.lemma_id;
      this.entryIDs = val.entry_ids;
      this.superLemma = val.super;
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/Zettelkasten.vue